// extracted by mini-css-extract-plugin
module.exports = {"miniModal":"MiniModal_miniModal__3IWvz","miniModalContent":"MiniModal_miniModalContent__2HdiZ","active":"MiniModal_active__3o81v"};